import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class IdentityService {



    constructor(private http:HttpClient) {
      
        
    }

     dologin(value:any){
        return  this.http.post<any>(`${environment.apiUrl}identity/login`,value);
  }

  doLogout() {
    return new Promise<void>((resolve, reject) => {
    
        localStorage.removeItem('currentUser');
       
        resolve();
     
    });
  }

  forgetPassword(value:any){
    return  this.http.post<any>(`${environment.apiUrl}identity/reset`,value);
  }

  changePassword(value:any){
    return  this.http.post<any>(`${environment.apiUrl}identity/changepassword`,value);
  }
}